const state = {
  cityValue:'',
  carNum: ''
}

const mutations = {
  setCityValue(state, cityValue) {
    state.cityValue = cityValue
  },
  setCarNum(state, carNum) {
    state.carNum = carNum
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}